import axios from 'axios'
import React, { useCallback, useContext, useEffect, useState } from 'react'
import { baseUrl } from '../../utils/baseUrl.js'
import { Link, useParams } from 'react-router-dom'
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/thumbs";
import "./../../thumbsSlide.css"
// import required modules
import { Autoplay, FreeMode, Navigation, Thumbs } from "swiper";
import { BsCartPlus } from 'react-icons/bs';
import { FaStar } from 'react-icons/fa';
import { VscHeart, VscHeartFilled, VscTrash } from 'react-icons/vsc';
import { AiOutlineMinus, AiOutlinePlus, AiOutlineShopping } from 'react-icons/ai';
import { toast } from 'react-toastify';
import { WishListContext } from '../../Context/WishListContext.jsx';
import { CartContext } from '../../Context/CartContext.jsx';
import { Avatar, Rating } from '@mui/material';
import LoadingPage from '../LoadingPage/LoadingPage.jsx';
import OrderModal from '../OrderModal/OrderModal.jsx';
import { Helmet, HelmetProvider } from 'react-helmet-async';



const Details = () => {
    const { addProductToWishList, removeProductFromWishList, contains, ids } = useContext(WishListContext)
    const { addProductToCart, removeProductFromCart, cartContains, cartIds } = useContext(CartContext)
    const [productDetails, setProductDetails] = useState({})
    const [quantity, setQuantity] = useState(1)
    const [orderQuantity, setOrderQuantity] = useState(1)
    const notify = (msg, type) => toast[type](msg);
    let params = useParams()
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const [orderModel, setOrderModal] = useState(false)
    const handleCloseOrderModal = () => setOrderModal(false)
    let token = localStorage.getItem('authorization')
    const getData = useCallback(async () => {
        const { data } = await axios.get(`${baseUrl}/products/${params.id}`)
        setProductDetails(data.product)
    }, [params.id])


    useEffect(() => {
        getData()
    }, [getData, params.id])


    function increaseQuantity(cb, quantity) {
        if (quantity >= productDetails?.stock) {
            notify("Quantity must be less than or equal to stock", "error")
        } else {
            cb(quantity + 1)
        }
    }
    function decreaseQuantity(cb, quantity) {
        if (quantity > 1) {
            cb(quantity - 1)
        } else {
            notify("Quantity must be at least one", "error")
        }
    }
    function getQuantity(e) {
        if (e.target.value > productDetails?.stock) {
            notify("Quantity must be less than or equal to stock", "error")
        } else {
            setQuantity(e.target.value)
        }
    }
    function getOrderQuantity(e) {
        if (e.target.value > productDetails?.stock) {
            notify("Quantity must be less than or equal to stock", "error")
        } else {
            setOrderQuantity(e.target.value)
        }
    }

    const removeReview = (reviewId, productId) => {
        axios(`${baseUrl}/reviews/${productId}`, {
            method: "DELETE",
            headers: {
                'Authorization': `ecomm__${token}`
            },
            data: {
                reviewId
            }
        }).then((response) => {
            notify(response.data.message, "success")
            getData()
        }).catch((error) => {
            notify("Can't delete this review", "error")
        })
    }

    return (
        <HelmetProvider>
            <Helmet>
                <title>FreshCart | Product</title>
            </Helmet>
            {productDetails && productDetails.subImages ?
                <div className="container py-5 relative">
                    <div className="flex gap-4 max-sm:flex-wrap justify-center">
                        <div className="sm:w-5/12 flex justify-center">
                            <div className="max-w-[300px] sm:max-w-[270px] m-auto shadow rounded p-2 select-none">
                                <Swiper
                                    style={{
                                        "--swiper-navigation-color": "#fff",
                                        "--swiper-pagination-color": "#fff",
                                    }}
                                    spaceBetween={20}
                                    thumbs={{ swiper: thumbsSwiper }}
                                    modules={[FreeMode, Thumbs, Autoplay]}
                                    autoplay={{
                                        delay: 4000,
                                        disableOnInteraction: false
                                    }}
                                    className="mySwiper2">
                                    {productDetails.subImages?.map((image, i) => (
                                        <SwiperSlide key={i} className='cursor-grab'>
                                            <img src={image.path} className="w-full" alt="ProductImage" />
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                                <Swiper
                                    onSwiper={setThumbsSwiper}
                                    spaceBetween={10}
                                    slidesPerView={4}
                                    freeMode={true}
                                    watchSlidesProgress={true}
                                    modules={[FreeMode, Navigation, Thumbs]}
                                    className="mySwiper">
                                    {productDetails.subImages?.map((image, i) => (
                                        <SwiperSlide key={i} className='duration-300 border rounded hover:border-green-700 cursor-pointer'>
                                            <img src={image.path} className="w-full border border-gray-700 rounded" alt="" />
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </div>
                        </div>
                        <div className="sm:w-8/12 px-4 sm:px-0">
                            <p className="text-gray-500 font-medium my-1"><Link to={`/brands/${productDetails.brandId?._id}`} className=''>{`${productDetails.brandId?.name?.charAt(0).toUpperCase() + productDetails.brandId?.name?.slice(1)}`}</Link></p>
                            <h2 className='text-2xl md:text-3xl font-medium'>{`${productDetails.name?.charAt(0).toUpperCase() + productDetails.name?.slice(1)}`}</h2>
                            <div className="flex gap-2 mt-2">
                                <div className='flex items-center gap-1.5 bg-gray-50 shadow-sm rounded py-1 px-3 w-max'>
                                    <FaStar className=" text-yellow-400" />
                                    <span>{productDetails.AvgRate}</span>
                                </div>
                                <div className='flex items-center bg-gray-50 shadow-sm rounded py-1 px-3 w-max'>
                                    <span>{productDetails.ratingCount} <span className="text-sm mx-1">Ratings</span></span>
                                </div>
                                <div className='flex items-center bg-gray-50 shadow-sm rounded py-1 px-3 w-max'>
                                    <span>{`${productDetails.categoryId?.name?.charAt(0).toUpperCase() + productDetails.categoryId?.name?.slice(1)}`}</span>
                                </div>
                            </div>
                            {productDetails.discount > 0 ?
                                <div className='my-4 flex flex-col gap-3'>
                                    <div className='flex items-center'>
                                        <span className='font-medium text-xl line-through opacity-60'>EGP {productDetails.price.toFixed(2)}</span>
                                    </div>
                                    <div className='flex items-center'>
                                        <span className='font-medium text-xl'>EGP {productDetails.priceAfterDiscount.toFixed(2)} <span className='font-medium text-xs'>Inclusive of VAT</span></span>
                                    </div>
                                    <div className='flex items-center'>
                                        <span className='font-medium text-base bg-green-400 py-1 px-2 rounded-xl text-white'>Save: {productDetails.discount}%</span>
                                    </div>
                                </div> : <div className='mt-3 flex items-center'>
                                    <span className='font-medium text-xl'>EGP {productDetails.price} <span className='font-medium text-xs'>Inclusive of VAT</span></span>
                                </div>}
                            <div className='mt-4 text-sm'>
                                <div>
                                    {productDetails.stock ? <span className=''><span className='font-medium text-xl me-1'>{productDetails.stock}</span> Item In Stock</span> : <span className='text-red-500'>Out of stock</span>}</div>
                            </div>
                            <div className='mt-4 text-sm flex gap-2'>
                                <span className='text-base '>Colors</span>{productDetails.colors?.map((color, i) => (
                                    <span key={i} className={` flex items-center bg-gray-50 shadow-sm rounded py-1 px-3 w-max`}>{color}</span>
                                ))}
                            </div>
                            <div className="flex flex-col xl:flex-row gap-3">
                                <div className='flex gap-2 mt-6 w-full flex-col xxs:flex-row'>
                                    <div className="w-full md:w-2/5 flex gap-1">
                                        <button onClick={() => decreaseQuantity(setQuantity, quantity)} className=" w-1/4 rounded bg-gray-300 hover:bg-gray-200 duration-100 flex items-center justify-center" ><AiOutlineMinus className="" /></button>
                                        <input onChange={getQuantity} type="text" min="1" className='w-1/2 p-2 border focus:outline-none text-neutral-600 rounded text-center' value={quantity} />
                                        <button onClick={() => increaseQuantity(setQuantity, quantity)} className="w-1/4 rounded bg-gray-300 hover:bg-gray-200 duration-100 flex items-center justify-center" ><AiOutlinePlus className="" /></button>
                                    </div>
                                    {!cartContains(cartIds, productDetails._id) ?
                                        <button onClick={() => addProductToCart(productDetails._id, quantity)} className='w-full md:w-3/5 flex items-center justify-center gap-2 py-2 px-10 bg-green-600 hover:bg-green-500 text-white rounded group'>
                                            <BsCartPlus className='group-hover:animate-bounce' />
                                            <span className='text-xs font-semibold  uppercase'> Add to cart</span>
                                        </button> :
                                        <button onClick={() => removeProductFromCart(productDetails._id)} className='w-full md:w-3/5 flex items-center justify-center gap-2 py-2 px-10 bg-red-600 hover:bg-red-500 text-white rounded group'>
                                            <BsCartPlus className='group-hover:animate-bounce' />
                                            <span className='text-xs font-semibold  uppercase'> Remove From Cart</span>
                                        </button>}
                                </div>
                                <div className='flex gap-3 mt-6 w-full flex-col xxs:flex-row'>
                                    <div className="w-full md:w-2/5 flex gap-1">
                                        <button onClick={() => decreaseQuantity(setOrderQuantity, orderQuantity)} className=" w-1/4 rounded bg-gray-300 hover:bg-gray-200 duration-100 flex items-center justify-center" ><AiOutlineMinus className="" /></button>
                                        <input onChange={getOrderQuantity} type="text" min="1" className='w-1/2 p-2 border focus:outline-none text-neutral-600 rounded text-center' value={orderQuantity} />
                                        <button onClick={() => increaseQuantity(setOrderQuantity, orderQuantity)} className="w-1/4 rounded bg-gray-300 hover:bg-gray-200 duration-100 flex items-center justify-center" ><AiOutlinePlus className="" /></button>
                                    </div>
                                    <button onClick={() => { setOrderModal(true) }} className='w-full md:w-3/5 flex items-center justify-center gap-2 py-2 px-10 bg-amber-600 hover:bg-amber-500 text-white rounded group'>
                                        <AiOutlineShopping size={16} className='group-hover:animate-bounce' />
                                        <span> Order Now</span>
                                    </button>
                                    <OrderModal onClose={handleCloseOrderModal} visible={orderModel} productId={productDetails._id} quantity={orderQuantity} />
                                </div>
                            </div>
                            <div className='absolute top-0 left-10 z-50'>
                                {!contains(ids, productDetails._id) ? <button onClick={() => addProductToWishList(productDetails?._id)} className='rounded text-red-800 p-1 border border-red-700 group'>
                                    <VscHeart className='group-hover:animate-bounce' size={18} />
                                </button> : <button onClick={() => removeProductFromWishList(productDetails?._id)} className='rounded text-red-800 p-1 border border-red-700 group'>
                                    <VscHeartFilled className='group-hover:animate-bounce' size={18} />
                                </button>}
                            </div>
                        </div>
                    </div>
                    <div className=" sm:p-5">
                        <div className="text-lg py-3 font-medium"><h2 className="text-xl my-2">Overview</h2> <span className=" text-sm font-normal text-gray-800 block">{productDetails?.description}</span></div>
                    </div>
                    <div className=" sm:p-5">
                        <div className="text-lg py-3 font-medium">
                            <h2 className="text-xl my-4">Reviews</h2>
                            {!productDetails.Reviews?.length ? <div className=" text-sm text-red-600 font-normal text-center">No Reviews yet</div> : <>
                                <div className="grid md:grid-cols-2 gap-4 my-3">
                                    {productDetails?.Reviews?.map((review, i) => {
                                        return (
                                            <div key={i} className="flex gap-3 flex-col rounded border py-3 px-2 relative">
                                                <div className="flex gap-4">
                                                    <Avatar src="/broken-image.jpg" />
                                                    <div className="flex flex-col">
                                                        <h3>Anonymous</h3>
                                                        <p className="text-slate-600 text-xs">{review.createdAt.split("T").slice(0, 1).join(" ")}</p>
                                                    </div>
                                                </div>
                                                <div className="flex flex-col px-5">
                                                    <Rating name="half-rating-read" defaultValue={review.rate} precision={0.25} readOnly />
                                                    <p className="text-slate-500 font-normal">{review.text}</p>
                                                </div>
                                                <div className="py-2 absolute end-2 top-0">
                                                    <button onClick={() => removeReview(review._id, review.productId)} className='flex items-center justify-center gap-1 p-1 border border-red-600 text-red-600 hover:bg-red-600 hover:text-white rounded group duration-300'>
                                                        <VscTrash className='group-hover:animate-bounce' size='16' />
                                                    </button>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </>}</div>
                    </div>
                </div>
                : <LoadingPage />}
        </HelmetProvider>
    )
}

export default Details